<template>
  <div class="page">
    <b-container class="fp-container">
      <b-row class="mt-3">
        <b-col offset-md="2" md="8">
          <h1>{{ title }}</h1>
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col md="8" offset="2" class="page-content">
          <p v-html="content" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Page',
  data () {
    return {
      title: '',
      content: '',
      loading: false
    }
  },
  mounted: function () {
    this.loadPage(this.$route.params.slug)
  },
  methods: {
    loadPage (slug) {
      const params = {
        'filter[name]': slug,
        rest_route: '/wp/v2/pages'
      }
      this.loading = true
      this.fetchPage(params, data => {
        if (data.length > 0) {
          this.title = data[0].title.rendered
          this.content = data[0].content.rendered
        } else {
          this.title = 'Sivua ei löydy'
          this.content = ''
        }
      })
    },
    fetchPage (params, callback) {
      this.axios
        .get('https://epuu.fi/', { params })
        .then(response => {
          this.loading = false
          callback(response.data)
        })
        .catch(error => {
          this.loading = false
          this.title = 'Latausvirhe'
          console.error(error)
        })
    }
  }
}
</script>

<style>
  .page .page-content h2 {
    font-size: 1.3rem;
    margin-bottom: 0.5rem;
  }
  .page-content img{
    max-width: 780px;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/Page.vue